import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0;}
  to { opacity: 1; }
`;

export const ErrorPageContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  transform: translateY(-60px);
  margin: 0 5vw;
  text-align: center;
  gap: 16px;
  animation: ${fadeIn} 0.6s ease-in-out;
`;
